import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/diagnostico";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class DiagnosticoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe ModuleApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    GetListDiagnostico() {
        return this.api<any>(`${controller}/GetListDiagnostico`, {
            method: "GET",
        });
    }

    PostListDiagnostico(
        codDiagnostico: number,
        titulo: string,
        descricao: string,
        query: string,
        chart: number,
        eixo: string,
        status: number,
        chartType: string
    ) {
        return this.api<any>(`${controller}/PostListDiagnostico`, {
            method: "POST",
            body: JSON.stringify({ codDiagnostico, titulo, descricao, query, chart, eixo, status, tipochart: chartType }),
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    ExecutarQery(query: string) {
        return this.api<any>(`${controller}/ExecutarQery`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Query: query }),
        });
      }
      
      SalvarOrdem(ini_Blob: { CodUsuario: number; Parametro: string; RegistroAplicacao: string; Valor: string }) {
        return this.api<any>(`ini/CadastrarIniBlob`, {
            method: "POST",
            body: ini_Blob,
        });
    }

    CarregarOrdem(parametro: string, registroAplicacao: string) {
        return this.api<any>(`ini/CarregarIniBlob`, {
            method: "GET",
            params: { parametro, registroAplicacao },
        });
    }

    DeleteDiagnostico(codDiagnostico: number) {
        return this.api<any>(`${controller}/DeleteDiagnostico`, {
            method: "POST",
            params: { codDiagnostico },
        });
    }

}
